import ScmePlugins from "./ScmePlugins";
import QuickAccess from "./QuickAccess";
import ValueLists from "./ValueLists";
import RecaptchaConfig from "./RecaptchaConfig";

export default function ConfigAdmin() {
  return (
    <div data-testid="config-page">
      <h1 className="font-display text-xl font-light mb-6">Configuración</h1>
      <QuickAccess />
      <RecaptchaConfig />
      <ValueLists />
      <ScmePlugins />
    </div>
  );
}
